<template>
  <div class="main userMain" v-if="hackReset">
    <audio id="audio" src="/static/video/notice.mp3"></audio>
    <el-container class="nav-container">
      <el-header class="header">
        <ms-nav @showNewGuideHandler='showNewGuide'></ms-nav>
      </el-header>
      <el-container class="container pr">
        <div class="newNotice" v-show="showNotice" :style="{right: right + 'px'}">
          <h6>有一条新资源！</h6>
          <p>为了保证资源的有效性，请及时处理。<a @click="noticeRouter">查看</a></p>
          <i class="el-icon-close" @click="closeNotice"></i>
        </div>
        <el-aside class="container-aside">
          <ms-menu :openArr='openArr'></ms-menu>
        </el-aside>
        <el-main class="container-main">
          <router-view :key="$route.fullPath" :dialogFlag='dialogFlag' :isShowNewGuide='isShowNewGuide' :currentIndex='currentIndex' @closeNewGuide='closeNewGuideHandler'></router-view>
        </el-main>
      </el-container>
    </el-container>
    <el-dialog :visible.sync="dialogFlag" center width="700px" top="18vh">
      <div class="content">
        <img src="../../../assets/images/blane.png" alt="">
        <h3>余额不足</h3>
        <p>当前以下项目可消费天数不足2天，赶快去充值吧~</p>
      </div>
      <div class="card">
        <el-card shadow="hover" v-for="(item, index) in balaList" :key="index" class="main-card">
          <el-tag>{{item.title}}</el-tag>
          <el-tag type="danger">{{item.canConsumeDay}}</el-tag>
        </el-card>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import Api from '@/api/statistics'
  import MsNav from '@/components/client/common/NavHome'
  import MsMenu from '@/components/client/common/Menu'
  import ResponseParse from '@/utils/response-parse'
  import moment from 'moment'
  export default {
    name: 'ms-client-container',
    components: {
      MsNav,
      MsMenu
    },
    data () {
      return {
        right: 0,
        showNotice: false,
        balaList: [],
        dialogFlag: false,
        hackReset: true,
        isShowNewGuide: false,
        currentIndex: 0,
        openArr: [],
        condition: {},
        checkData: {},
        step: 1,
        timer: '',
        checkTimer: '',
        whetherVoice: 0
      }
    },
    beforeCreate () {
      const userInfo = this.$cookie.get('_qd_emcp.l_s')
      if (!userInfo) {
        this.$router.push('/')
      }
    },
    created () {
      this.right = (document.documentElement.scrollWidth - 1360) / 2
      this.requestList()
      this.hackReset = false
      this.$nextTick(() => {
        this.hackReset = true
        this.isLoad = true
      })
      let date = []
      let IdList = []
      date[0] = moment().subtract(0, 'days').format('YYYY-MM-DD')
      this.condition.startTime = date[0]
      this.condition.endTime = date[0]
      this.checkFeedback()
      clearInterval(this.timer)
      this.checkTimer = setInterval(this.checkFeedback, 180000)
      // this.checkTimer = setInterval(this.checkFeedback, 3000)
    },
    methods: {
      checkFeedback () {
        Api.FeedbackList({search: this.condition}, response => {
          let status = response.status || 0
          let body = response.data || {}
          if (status === 200 || status === 204) {
            const firstData = sessionStorage.getItem('feedback')
            const count = ResponseParse.pagination(response.headers)
            const countNum = count.totalRow
            if (firstData === null) {
              sessionStorage.setItem('feedback', countNum)
            } else {
              this.checkData.feedback = countNum
              if (firstData < countNum) {
                this.notice(1)
              } else {
                this.checkFormList()
              }
            }
          } else {
            this.checkFormList()
          }
        })
      },
      checkFormList () {
        Api.FormList({search: this.condition}, response => {
          let status = response.status || 0
          let body = response.data || {}
          if (status === 200 || status === 204) {
            const firstData = sessionStorage.getItem('formList')
            const count = ResponseParse.pagination(response.headers)
            const countNum = count.totalRow
            if (firstData === null) {
              sessionStorage.setItem('formList', countNum)
            } else {
              this.checkData.formList = countNum
              if (firstData < countNum) {
                this.notice(2)
              } else {
                this.checkResourceList()
              }
            }
          } else {
            this.checkResourceList()
          }
        })
      },
      checkResourceList () {
        Api.ResourceList({search: this.condition}, response => {
          let status = response.status || 0
          let body = response.data || {}
          if (status === 200 || status === 204) {
            const firstData = sessionStorage.getItem('resource')
            const count = ResponseParse.pagination(response.headers)
            const countNum = count.totalRow
            if (firstData === null) {
              sessionStorage.setItem('resource', countNum)
            } else {
              this.checkData.resource = countNum
              if (firstData < countNum) {
                this.notice(3)
              }
            }
          }
        })
      },
      notice (index) {
        clearInterval(this.timer)
        const whetherVoice = this.$store.state.user.info.whetherVoice
        console.log(whetherVoice)
        if (whetherVoice === 0) {
          const audio = document.querySelector('#audio')
          audio.play()
        }
        this.checkData.type = index
        this.showNotice = true
        this.timer = setInterval(this.flash_title, 1000)
      },
      flash_title () {
        this.step++
        if (this.step === 3) { this.step = 1 }
        if (this.step === 1) { document.title = '[请尽快处理]有新的通知' }
        if (this.step === 2) { document.title = '            你有一条新通知' }
      },
      noticeRouter () {
        this.closeNotice()
        const type = this.checkData.type
        if (type === 1) {
          sessionStorage.setItem('feedback', this.checkData.feedback)
          this.$router.push('/feedback')
        } else if (type === 2) {
          sessionStorage.setItem('formList', this.checkData.formList)
          this.$router.push('/info-list')
        } else if (type === 3) {
          sessionStorage.setItem('resource', this.checkData.resource)
          this.$router.push('/resource')
        }
      },
      closeNotice () {
        clearInterval(this.timer)
        this.showNotice = false
        document.getElementsByTagName('title')[0].innerHTML = '渠道无忧'
      },
      requestList () {
        let search = Object.assign({})
        Api.theBalanceTo({search: search}, response => {
          let status = response.data.code
          let body = response.data.data
          if (status === '200') {
            body.forEach(item => {
              if (item.canConsumeDay <= 2) {
                this.balaList.push({'title': item.title, 'canConsumeDay': '可消费天数：' + item.canConsumeDay.toFixed(2) + ' 天'})
              }
            })
            if (this.balaList.length > 0) {
              // this.dialogFlag = true
            } else {
              this.dialogFlag = false
            }
            return this.balaList
          } else {
            this.balaList = []
          }
        })
      },
      closeNewGuideHandler () {
        this.isShowNewGuide = false
      },
      showNewGuide () {
        const path = this.$router.history.current.path
        if (path !== '/work-bench') {
          this.$router.replace('/work-bench')
        }
        this.isShowNewGuide = true
        this.currentIndex = 0
        this.openArr = []
        this.$forceUpdate()
      },
      setOpenArr (e, keyPath) {
        // this.openArr = keyPath
      }
    },
    beforeDestroy () {
      clearInterval(this.checkTimer)
      this.closeNotice()
    }
  }
</script>

<style scoped="scoped" lang="scss">
  @import '../../../assets/styles/_env.scss';
  .newNotice{
    position: fixed;
    top:80px;
    // width:284px;
    height:61px;
    background:rgba(255,249,224,1);
    border:1px solid rgba(255,238,187,1);
    opacity:0.94;
    z-index: 9999;
    border-radius:0px 0px 3px 3px;
    padding: 11px 30px 12px 15px;
    box-sizing: border-box;
    h6{
      margin:0;
      margin-bottom: 5px;
      font-size:12px;
      font-weight:bold;
      color:rgba(51,51,51,1);
    }
    p{
      margin:0;
      font-size:12px;
      font-weight:300;
      color:rgba(51,51,51,1);
    }
    a{
      color:#EB7350;
      cursor: pointer;
    }
    .el-icon-close{
      color:#666666;
      font-weight: bold;
      position: absolute;
      top:15px;
      right:10px;
      cursor: pointer;
    }
  }
  .main{
    width: 100%;
    .nav-container{
      background: #f5f5f5;
      .header{
        width: 100%;
        height:60px !important;
        padding: 0;
        margin: 0 auto;
        background: $color-white;
      }
      .container{
        width: 100%;
        min-height: 1350px;
        padding: 20px 0 200px 0;
        box-sizing: border-box;
        margin: 0 auto;
        overflow: visible;
        background: #f5f5f5;
        .container-aside{
          width: 182px !important;
          min-height: 1012px;
          background: white;
          border: 1px solid $color-cut-line;
          position: absolute;
          left: 0;
          top: 30px;
        }
        .container-main{
          overflow: visible;
          width: 1030px;
          padding-top: 10px;
          margin-left:180px;
        }
      }
    }
    .content{
      width: 100%;
      text-align: center;
      h3 {
        font-size: 20px;
        letter-spacing: 4px;
      }
      p {
        font-size: 15px;
        color: #999;
      }
    }
    .card{
      width: 100%;
      min-height: 200px;
      padding: 20px 120px;
      box-sizing: border-box;
      overflow: hidden;
      zoom: 1;
      position: relative;
      .el-card{
        width: 320px;
        float: left;
        margin:10px 15px;
        text-align: center;
      }
      .main-card{
        width: 100%;
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/client/common/Content.vue